import { createBridgeChannel } from '@robinpowered/dashboard-apps-common';
var deleteRequested = createBridgeChannel('dashboard:event-details:delete-requested');
var actionSuccess = createBridgeChannel('dashboard:event-details:action-success');
var actionError = createBridgeChannel('dashboard:event-details:action-error');
export var emitEventDetailsDeleteRequested = deleteRequested.emit;
export var onEventDetailsDeleteRequested = deleteRequested.subscribe;
export var useEmitEventDetailsDeleteRequested = deleteRequested.useEmit;
export var useEventDetailsDeleteRequested = deleteRequested.useSubscribe;
export var emitEventDetailsActionSuccess = actionSuccess.emit;
export var onEventDetailsActionSuccess = actionSuccess.subscribe;
export var useEmitEventDetailsActionSuccess = actionSuccess.useEmit;
export var useEventDetailsActionSuccess = actionSuccess.useSubscribe;
export var emitEventDetailsActionError = actionError.emit;
export var onEventDetailsActionError = actionError.subscribe;
export var useEmitEventDetailsActionError = actionError.useEmit;
export var useEventDetailsActionError = actionError.useSubscribe;
